<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import store from "@/store";

import { PanelTheme } from "@/common/themes";
import { baseAvatar, baseConfirm, tabMenu } from "@/common/components";
</script>

<template>
	<article class="home-page">HOME</article>
</template>
